import { createReducer } from "@reduxjs/toolkit";
import {
    OTP_AUTH_RESET_SESSION,
    OTP_AUTH_SET_ERROR,
    OTP_AUTH_SET_USER_ID,
    OTP_AUTH_VERIFY_USER_ID_REQUESTED,
    OTP_AUTH_VERIFY_USER_ID_SUCCEEDED,
    OTP_AUTH_VERIFY_USER_ID_FAILED,
    OTP_AUTH_SET_VERIFICATION_CODE,
    OTP_AUTH_VERIFY_CODE_REQUESTED,
    OTP_AUTH_VERIFY_CODE_SUCCEEDED,
    OTP_AUTH_VERIFY_CODE_FAILED,
    OTP_AUTH_GO_TO_SCREEN,
    OTP_AUTH_SET_LOADING,
    OTP_AUTH_SET_IS_VALID
} from "./actions";

 export const defaultState = {
    code: null,
    codeSentAt: null,
    error: {},
    screen: "",
    userId: false,
    uuid: false,
    sessionTimestamp: null,
    loading: false,
    isValid: false
};

const otpAuth = createReducer(defaultState, (builder) =>
    builder
        .addCase(OTP_AUTH_RESET_SESSION, (state) => {
            state.sessionTimestamp = Date.now();
        })
        .addCase(OTP_AUTH_SET_ERROR, (state, { payload }) => {
            if (payload.valid === false) {
                state.error[payload.id] = payload;
            } else if (payload.valid === true && state.error[payload.id]) {
                delete state.error[payload.id];
            }
        })
        .addCase(OTP_AUTH_SET_USER_ID, (state, { payload }) => {
            state.userId = payload;
        })
        .addCase(OTP_AUTH_SET_IS_VALID, (state, { payload }) => {
            state.isValid = payload;
        })
        .addCase(OTP_AUTH_SET_LOADING, (state, { payload }) => {
            state.loading = payload;
        })
        .addCase(OTP_AUTH_VERIFY_USER_ID_REQUESTED, (state, { payload }) => {
            state.userId = payload;
            state.codeSentAt = Date.now();
            state.error = {};
        })
        .addCase(OTP_AUTH_VERIFY_USER_ID_FAILED, (state, { payload }) => {
            state.userId = false;
            state.error = payload;
        })
        .addCase(OTP_AUTH_VERIFY_USER_ID_SUCCEEDED, (state, { payload }) => {
            state.uuid = payload.uuid;
            state.error = {};
        })
        .addCase(OTP_AUTH_SET_VERIFICATION_CODE, (state, { payload }) => {
            state.code = payload;
        })
        .addCase(OTP_AUTH_VERIFY_CODE_REQUESTED, (state, { payload }) => {
            state.uuid = payload;
        })
        .addCase(OTP_AUTH_VERIFY_CODE_FAILED, (state, { payload }) => {
            if (payload.status === "terminate_session") {
                state.error = {};
                state.uuid = false;
            } else if (payload.status === "validation") {
                state.error = payload;
            } else {
                state.error = {};
            }
        })
        .addCase(OTP_AUTH_VERIFY_CODE_SUCCEEDED, (state, { payload }) => {
            state.uuid = payload.uuid;
            state.sessionTimestamp = Date.now();
            state.error = {};
        })
        .addCase(OTP_AUTH_GO_TO_SCREEN, (state, { payload }) => {
            state.sessionTimestamp = Date.now();
            state.screen = payload;
            state.error = {};
        })
);

export default otpAuth;
